import { ModalProps } from '../../types/modal'
import Modal from '../shared/Modal'
import Button from '@components/shared/Button'
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { localStorageKey } from 'hooks/useLocalStorageState'
import Image from 'next/image'
import GlowBadge from '@components/shared/GlowBadge'
import DiscordIcon from '@components/icons/DiscordIcon'
import { TWITTER_LINK, DISCORD_LINK, TELEGRAM_LINK } from 'utils/constants'
import { XIcon } from '@components/icons/XIcon'
import { useTranslation } from 'next-i18next'
import { ExternalLink } from '@components/shared/ExternalLink'
import TelegramIcon from '@components/icons/TelegramIcon'

export const SEEN_INTRO_KEY = localStorageKey('seenIntroKey-0.2', false)

const IntroModal = ({ isOpen, onClose }: ModalProps) => {
  const { t } = useTranslation('intro')

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      disableOutsideClose
      hideClose
      panelClassNames="px-0 pt-0 sm:px-0 sm:pt-0"
    >
      <div className="mb-4">
        <div className="mb-4 h-auto w-full">
          <Image
            className="sm:rounded-t-lg"
            src="/images/welcome-banner.webp"
            alt="Welcome to Cabana"
            height={270}
            width={672}
          />
        </div>
        <div className="px-4 sm:px-6">
          <div className="border-b border-th-bkg-4 pb-4">
            <p className="mb-2 text-center text-th-fgd-1 sm:text-base">
              {t('tagline')}
            </p>
            <div className="flex items-center justify-center space-x-3">
              <div className="flex items-center gap-2">
                <DiscordIcon className="size-4 text-th-fgd-1" />
                <ExternalLink
                  className="text-th-fgd-2 focus:outline-none md:hover:text-th-fgd-1"
                  href={DISCORD_LINK}
                >
                  {t('joinDiscord')}
                </ExternalLink>
              </div>
              <span className="text-th-fgd-4">|</span>
              <div className="flex items-center gap-2">
                <XIcon className="size-4 text-th-fgd-1" />
                <ExternalLink
                  className="text-th-fgd-2 focus:outline-none md:hover:text-th-fgd-1"
                  href={TWITTER_LINK}
                >
                  {t('followUs')}
                </ExternalLink>
              </div>
              <span className="text-th-fgd-4">|</span>
              <div className="flex items-center gap-2">
                <TelegramIcon className="size-4 text-th-fgd-1" />
                <ExternalLink
                  className="text-th-fgd-2 focus:outline-none md:hover:text-th-fgd-1"
                  href={TELEGRAM_LINK}
                >
                  Telegram
                </ExternalLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 sm:px-6">
        <div className="space-y-2">
          <CheckBullet text={t('features.leaderboard')} />
          <CheckBullet text={t('features.orderBook')} />
          <CheckBullet text={t('features.swapRouter')} />
          <CheckBullet text={t('features.createMarkets')} />
        </div>
        <Button className="mt-6 w-full" onClick={onClose} size="large">
          {t('getStarted')}
        </Button>
      </div>
    </Modal>
  )
}

export default IntroModal

const CheckBullet = ({
  text,
  isComingSoon,
}: {
  text: string
  isComingSoon?: boolean
}) => {
  const { t } = useTranslation('intro')

  return (
    <div className="flex items-center space-x-2">
      <CheckCircleIcon className="size-5 shrink-0 text-th-up" />
      <div className="flex items-center gap-2">
        <span className="text-th-fgd-2">{text}</span>
        {isComingSoon ? <GlowBadge text={t('comingSoon')} /> : null}
      </div>
    </div>
  )
}
